<div class="dialog">
  <div class="dialog__header">
    <h1 class="dialog__title">サブステータス選択</h1>
    <span class="close" (click)="close()"></span>
  </div>
  <div class="dialog__body">
    <div class="dialog__contents">
      <!-- サブステータス情報が未登録の場合のメッセージ -->
      <div
        *ngIf="selectableJobScreeningInfoLabels.length === 0"
        class="empty-message"
      >
        <p class="empty-message__text">
          {{ emptyMessage }}
        </p>
      </div>
      
      <!-- サブステータス情報が登録されている場合のフォーム -->
      <ng-container *ngIf="selectableJobScreeningInfoLabels.length > 0">
        <ag-dynamic-form
          [metadata]="jobScreeningInfoMeta"
          [model]="jobScreeningInfoDataModel"
          (changed)="onJobScreeningInfoChanged($event)"
          *ngIf="jobScreeningInfoMeta && jobScreeningInfoDataModel"
        ></ag-dynamic-form>
        <ag-dynamic-form
          [metadata]="jobScreeningInfo2Meta"
          [model]="jobScreeningInfoDataModel"
          *ngIf="jobScreeningInfo2Meta && selectedJobScreeningInfoData"
        ></ag-dynamic-form>
      </ng-container>
    </div>
  </div>
  <div class="dialog__footer">
    <button class="dialog__button dialog__button--accent" (click)="close()">
      キャンセル
    </button>
    <button
      [disabled]="!isValidJobScreeningInfoData()"
      class="dialog__button dialog__button--primary"
      (click)="start()"
    >
      サブステータス開始
    </button>
  </div>
</div>
